import React, { Component } from "react";
import classnames from "classnames";
import Util from "../../streaming/Util";
import axios from "axios";
import $ from 'jquery';
import playerFunctions from "../../utils/playerFunctions";
import SessionDataStore from "../../streaming/SessionDataStoreController";
import { isChrome as chrome, isSafari as safari, isBrowser as browser, isFirefox as ff, osName as osname, fullBrowserVersion as fbrowserversion, browserName, deviceType, isMobileOnly as mobileOnly, isTablet as tablet, isIPad13 as ipad13, isAndroid as android} from "react-device-detect";

class OndemandPlayer extends Component {
	
	constructor(props) {
    super(props);
	
    this.state = {
      sessionScript: 0,
      isScriptAvailable: false,
      currentUserData: JSON.parse(localStorage.getItem('userData')),
      pause:true,
      player:null,
      playerSwap:null,
      progressBar:0,
      muted:false,
      videoDuration:false,
      can_change_duration:false,
      videoDurationCalculated:false,
      manualPaused:false,
      pauseScript:false,
  	  whiteboardLoaded: window['userWhiteboard'] && window['userWhiteboard'][JSON.parse(localStorage.getItem('userData')).id] ? true : false,
  	  videosSwapped: false,
  	  supportPageName: 'On Demand',
  	  supportPageApi: '/ondemand',
  	  userTypeFaqs: 1,
	  showPlayer: false,
	  videoStopedStatus: false,
	  checkEndVideo: false,
	  activityArray: []
    };
	
	this.sessionDataStore = SessionDataStore.getInstance();
	this.playerFunctions = new playerFunctions();
	this.syncArr = [];
	this.emojiArr = [];
	this.recordingStartTimeActual = null;
    this.recordingStartTime = null;
    this.recordingEndTime = null;
	window['onDemand'] = true;
	window['currentUserData'] = this.state.currentUserData;
	window['disableViewInterval'] = this.disableViewInterval;
	this.progressPaused = false;
	window.syncScriptTimeout = 0;
	window.pauseVideo = this.pauseVideo;
	window.playVideo = this.playVideo;
  }
  
	componentDidMount(){
		this.setState({isScriptAvailable: this.state.currentUserData.sessionData.scriptDetail !== undefined && this.state.currentUserData.sessionData.scriptDetail.length > 0}, () => { if(!this.state.isScriptAvailable) { $('#footerId').addClass('script_background_none'); } });
        this.setState({sessionScript: this.state.currentUserData.sessionData.id, player: document.getElementById('replayClassVideo'), playerSwap: document.getElementById('replayClassVideoSwap'), progressBar: document.getElementById('progress-bar')});
		
		this.setState({activityArray: this.state.currentUserData.sessionData.scriptDetail});
		
		this.initListeners();
		this.prepareData();
	}
	
	disableViewInterval=()=>{
		this.progressPaused = true;
		window['clearViewInterval']();
	}
	
    playPause = (fPlay) => {
        if (this.state.pause === false && fPlay !== 'forcePlay' ) {
	  	  console.log('playPause playing - do pause');
			this.progressPaused = true;
			window['clearViewInterval']();
            this.setState({pause: true});
            this.state.player.pause();
			if ( this.state.playerSwap && this.state.playerSwap.src != '' ) { this.state.playerSwap.pause(); }
			
            if ( this.state.isScriptAvailable ) {
                clearInterval(this.syncTimer);
                if ( !window.isPaused ) {
                    this.setState({manualPaused: true});
                    window.isPaused = true;
                }
				
				if ( window['scriptStarted'] ) { window.onChannelMessage({text: "213~@$1", messageType: "TEXT"}, this.state.currentUserData.sessionData.hostEmail, true); }
            }
    
            let addObject = {"userId": this.state.currentUserData.id, "event": "video", "eventType": "pause", "details": JSON.stringify({"onDemandId": this.state.currentUserData.sessionData.ondemandId, "platform": this.platformDetails}), "timestamp": Util.getCurrentTimestamp()};
            this.sessionDataStore.addSessionData(addObject);
        } else {
			console.log('playPause pause - do play');
			this.progressPaused = false;
            this.setState({pause: false, videoStopedStatus: false, checkEndVideo: false});
	  	    this.videoStopped = false;
            this.state.player.play();
			if ( this.state.playerSwap && this.state.playerSwap.src != '' ) { this.state.playerSwap.play(); }
			
            let addObject = {"userId": this.state.currentUserData.id, "event": "video", "eventType": "play", "details": JSON.stringify({"onDemandId": this.state.currentUserData.sessionData.ondemandId, "platform": this.platformDetails}), "timestamp": Util.getCurrentTimestamp()};
            this.sessionDataStore.addSessionData(addObject);
	  	  
            if ( this.state.isScriptAvailable ) {
				window.isPaused = false;
									  
				if ( this.state.manualPaused === true ) {
					//window.onChannelMessage({text: "211~@$1", messageType: "TEXT"}, this.state.currentUserData.sessionData.hostEmail, true);
					
					let duration = Math.floor(this.state.player.currentTime);
					this.calculateTimeDiff(duration);
					
					if ( window['userWhiteboard'] && window['userWhiteboard'][this.state.currentUserData.id] && window['userWhiteboard'][this.state.currentUserData.id].globalActType != "" )
						{
							window['userWhiteboard'][this.state.currentUserData.id].doActivityEvents('activityStarted');
						}
					this.setState({manualPaused: false});
				}
		
				if (this.state.progressBar.value == 100) {
					this.resetScript();
				}
            }
        }
    }
  
	resetScript = ()=> {
		$('#stop1-script').trigger('click');
	}
 
	stopVideo = () => {
		console.log('stopVideo');
		this.progressPaused = true;
		window['clearViewInterval']();
		this.videoStopped = true;
		this.state.player.pause();
		if ( this.state.playerSwap && this.state.playerSwap.src != '' ) { this.state.playerSwap.pause(); }
		this.setState({pause: true, videoStopedStatus: true});
		if (this.state.player.currentTime) {
			this.state.player.currentTime = 0;
			if ( this.state.playerSwap && this.state.playerSwap.src != '' ) { this.state.playerSwap.currentTime = 0; }
		}
		this.state.progressBar.value = 0;
		this.setState({videoDuration: 0});
		
		window['hostStartedEquipment'+this.state.currentUserData.id] = false;
		$('#canvasWrap').addClass('d-none');
		
		window.onChannelMessage({text: "212~@$0", messageType: "TEXT"}, this.state.currentUserData.sessionData.hostEmail, true);
		window.onChannelMessage({text: "feedFm~@$stop", messageType: "TEXT"}, this.state.currentUserData.sessionData.hostEmail, true);
		
		window.pauseVirtualActivityStarted = false;
		window.changeGlobalActType('', parseInt(this.state.currentUserData.id));
		
		let addObject = {"userId": this.state.currentUserData.id, "event": "video", "eventType": "stop", "details": JSON.stringify({"onDemandId": this.state.currentUserData.sessionData.ondemandId, "platform": this.platformDetails}), "timestamp": Util.getCurrentTimestamp()};
		this.sessionDataStore.addSessionData(addObject);

		if ( this.state.isScriptAvailable ) {
			clearInterval(this.syncTimer);
			this.resetScript();
			this.recordingStartTime = this.recordingStartTimeActual;
			
			if ( this.state.videosSwapped )
				{
					this.swapVideos();
					this.setState({videosSwapped:false});
				}
		}

		$('#fitness-counter').text(0);
	
		this.stopPlayer();
    }
	
	updateProgressBar = () => {
		if ( !window['viewIntervalStarted'] && !this.progressPaused ) { window['viewIntervalStarted'] = true; console.log('startWatchTimeInterval 111'); window['startWatchTimeInterval'](); }
		// Work out how much of the media has played via the duration and currentTime parameters
		var percentage = (100 / this.state.player.duration) * this.state.player.currentTime;
		// Update the progress bar's value
		if (isNaN(percentage)) {
			this.state.progressBar.value = 0;
		} else {
			this.state.progressBar.value = percentage;
		}
	
		this.applyFill(this.state.progressBar);
	
		let duration = Math.floor(this.state.player.currentTime);
		$('#time-elapsed').text(Util.convertSecondsToTime(duration));
		this.setState({videoDuration: percentage});
	
		if ( percentage == 100 ) {
			window.isPaused = true;
			this.lastTime = null;
		}
		
		if ( this.state.isScriptAvailable )
			{
				let currTimeMS = this.state.player.currentTime;
				let currTime = Math.round(this.state.player.currentTime);
				let timeDiff = currTime - currTimeMS;
				var lastTimeVar = this.lastTime;
			
				if ( timeDiff < 0.300000 )
					{  
						if ( this.lastTime != currTime && this.state.pause == false )
							{
								this.lastTime = currTime;
								//this.syncScript(currTime);
							}
					}
			}
    }
	
	applyFill = (slider) => {
      // First let's set the colors of our sliders
      const settings={
        fill: '#121126',
        background: '#434343'
      }

      // Let's turn our value into a percentage to figure out how far it is in between the min and max of our input
      const percentage = 100*(slider.value-slider.min)/(slider.max-slider.min);
      // now we'll create a linear gradient that separates at the above point
      // Our background color will change here
      const bg = `linear-gradient(90deg, ${settings.fill} ${percentage}%, ${settings.background} ${percentage+0.1}%)`;
      slider.style.background = bg;
    }
	
	initListeners = () => {
		
		if ( !document.getElementById('replayClassVideo') )
			{
				if ( this.props.ondemandErrorMsg )
					{
						this.props.ondemandErrorMsg();
					}
				return false;
			}
		document.getElementById('replayClassVideo').addEventListener('timeupdate', this.updateProgressBar, false);
		document.getElementById('replayClassVideo').addEventListener('ended', this.endVideo, false);

		document.getElementById('progress-bar').addEventListener("click", this.seek);
		document.getElementById('progress-bar').addEventListener("mousedown", this.slideSeek1);
		
		let duration = Math.floor(document.getElementById('replayClassVideo').duration);
		$('#video-duration').text(Util.convertSecondsToTime(duration));
		this.setState({videoDurationCalculated: true});
		$('.main_loader').hide();
		$('.main_loader').addClass('video_behind_loader');

		if ( !safari ) 
		{
			setTimeout(() => {
				this.playPause('forcePlay');
				console.log('playPause 441');
			}, 1000);
		}
		
		/* document.getElementById('replayClassVideo').addEventListener('loadedmetadata', () => {
			let duration = Math.floor(document.getElementById('replayClassVideo').duration);
			$('#video-duration').text(Util.convertSecondsToTime(duration));
			this.setState({videoDurationCalculated: true});
			$('.main_loader').hide();
			$('.main_loader').addClass('video_behind_loader');
	
			if ( !safari ) 
			{
				setTimeout(() => {
					this.playPause('forcePlay');
					console.log('playPause 441');
				}, 1000);
			}
		}); */
		
		document.getElementById('replayClassVideo').addEventListener('waiting', () => {
			console.log('video data buffering...');
			window.isPaused = true;
			this.buffering = true;
		});
		document.getElementById('replayClassVideo').addEventListener('playing', () => {
			console.log('video data playing...');
			$('.main_loader').hide();
			$('.main_loader').addClass('video_behind_loader');
	
			if (this.buffering) {
				this.buffering = false;
				window.isPaused = false;
				console.log('paused 7');
			}
		});
    }
	
	endVideo = () => {
	
	  if ( window['stopFmAtEndOfOnDemand'] )
		{
			window['stopFmAtEndOfOnDemand']();
		}
      console.log('video ended======');
	  this.progressPaused = true;
	  window['clearViewInterval']();
	  if ( window.disableCalculatingAR ) { window.disableCalculatingAR(); }
      if (this.state.pause === false) {
          this.setState({pause: true});
          this.state.player.pause();
		  if ( this.state.playerSwap && this.state.playerSwap.src != '' ) { this.state.playerSwap.pause(); }
      } else {
          this.setState({pause: false});
          this.state.player.play();
		  if ( this.state.playerSwap && this.state.playerSwap.src != '' ) { this.state.playerSwap.play(); }
      }
	  
	  window.onChannelMessage({text: "212~@$0", messageType: "TEXT"}, this.state.currentUserData.sessionData.hostEmail, true);
	  
	  this.setState({checkEndVideo: true});
      this.state.progressBar.value = 100;
      clearInterval(this.syncTimer);
	  
	  if ( this.state.whiteboardLoaded )
		{
			$('#canvasWrap').addClass('d-none');
			window.pauseVirtualActivityStarted = false;
			window.changeGlobalActType('', parseInt(this.state.currentUserData.id));
			if ( this.state.videosSwapped )
				{
					this.swapVideos();
					this.setState({videosSwapped:false});
				}
		}
	  if ( localStorage.getItem('groupClass') !== null )
		{
			var sendData = JSON.parse(localStorage.getItem('groupClass'));
			let token = JSON.parse(localStorage.getItem('userData')).token;
			axios.defaults.headers.common['Authorization'] = token;
			axios.post(process.env.REACT_APP_API_URL+'/api/v1/programs/classCompleted', sendData).then(res => {
				$('.main_loader').hide();
			}).catch(err =>{ });   
		}
    }
	
	swapVideos = () => {
	  var elm1 = $('#local_preview');
      var elm2 = $('#replayClassVideo');
	  
	  var parent1, next1,
          parent2, next2;
	  parent1 = elm1[0].parentNode;
	  next1   = elm1[0].nextSibling;
	  parent2 = elm2[0].parentNode;
	  next2   = elm2[0].nextSibling;
	  parent1.insertBefore(elm2[0], next1);
      parent2.insertBefore(elm1[0], next2);
	  
	  elm2[0].style.marginLeft = 0;
	  
	  $('.particlecontainer').css('pointer-events', 'none');
	  
	  console.log($('#replayClassVideo').attr('style'));
	  
	  if ( !this.state.videosSwapped )
		{
			$('.video-holder').css('transition', '1s');
			$('.video-holder').addClass('hostCamLeft');
			$('.hostCamBack').removeClass('d-none');
			$('.hostCamBack').removeClass('backLeft');
			$('#launcher').css({'transition': '1s', 'right': '-95px'});
			$('#activityCounter').removeClass('d-none');
			$('#activityName').removeClass('d-none');
			$('#repcounter').removeClass('d-none');
			this.hideShowFooter(true);
		}
	  else
		{
			$('.video-holder').removeClass('hostCamLeft');
			$('.hostCamBack').addClass('d-none');
			$('#launcher').css('right', '0px');
			$('#activityCounter').addClass('d-none');
			$('#activityName').addClass('d-none');
			$('#repcounter').addClass('d-none');
			$('.participant_stats_hold').addClass('d-none');
			this.hideShowFooter(false);
		}
    }
	
	muteUnmuteVideo = () => {
      if (this.state.muted === false) {
          this.setState({muted: true});
          this.state.player.muted = true;
		  if ( this.state.playerSwap && this.state.playerSwap.src != '' ) { this.state.playerSwap.muted = true; }
      } else {
          this.setState({muted: false});
          this.state.player.muted = false;
		  if ( this.state.playerSwap && this.state.playerSwap.src != '' ) { this.state.playerSwap.muted = false; }
      }
    }
	
	seek = (e) => {
      window.$('.main_loader').attr({'style':'display:flex'});
      window.$('.main_loader').removeClass('video_behind_loader');

      this.applyFill(e.target);
      let progressBarValue = 0;

      if (this.state.isScriptAvailable) {
		console.log('isScriptAvailable');
        this.state.player.pause();
		if ( this.state.playerSwap && this.state.playerSwap.src != '' ) { this.state.playerSwap.pause(); }
        this.setState({pause: true});
        clearInterval(this.syncTimer);
      }

      var curr_item = e.currentTarget;
      var move_left = e.pageX - $(curr_item).offset().left;

      var position = (move_left / parseInt($(curr_item).width()));
      this.state.player.currentTime = position * this.state.player.duration;
	  if ( this.state.playerSwap && this.state.playerSwap.src != '' ) { this.state.playerSwap.currentTime = position * this.state.player.duration; }

      let duration = Math.floor(this.state.player.currentTime);
      $('#time-elapsed').text(Util.convertSecondsToTime(duration));
      this.setState({videoDuration: e.target.value});
	  this.stopPlayer();

      if (this.state.isScriptAvailable) {
          this.calculateTimeDiff(duration);
      } else {
          this.setState({pause: false});
          this.state.player.play();
		  if ( this.state.playerSwap && this.state.playerSwap.src != '' ) { this.state.playerSwap.play(); }
      }
    }
	
	calculateTimeDiff = (duration) => {
		this.deadline = new Date(this.recordingStartTimeActual).getTime() + (duration * 1000);
		console.log('progress deadline new - ', this.deadline, duration);
		
		let prevData = '';
		this.syncArr.forEach((scriptData)=>{
			if ( scriptData.time <= this.deadline && scriptData.rtm != 202 ) {
				prevData = scriptData;
			}
		});
		
		console.log('prevData', prevData);
		
		this.syncFitnessScript(prevData);
    }
	
	syncFitnessScript = (resultant) => {
      console.log('seek script - ', resultant);
      
	  var activities = this.state.activityArray;
	  
      this.resetScript();
      let that = this;

      window.syncScriptTimeout = setTimeout(function(){
		  
		  for ( let i = 0; i < activities.length; i++ )
			{
				if ( resultant.index == i+1 )
					{
						  let timeDiff = (that.deadline - resultant.time) / 1000;
						  let timeRemaining = 0;

						  /* if ($(this).find('.interval').length > 0) {
							  let totalTime = parseInt($(this).find('.countdown-number').attr('data-number')) * parseInt($(this).find('.interval').attr('intervaltime'));
							  timeRemaining = totalTime - timeDiff;
							  $(this).find('#reps-counter').text(timeRemaining);

							  let timeElapsed = totalTime - timeRemaining;
							  let repsRemaining = parseInt($(this).find('.countdown-number').attr('data-number')) - Math.floor(timeElapsed / parseInt($(this).find('.interval').attr('intervaltime')));
							  $(this).find('.countdown-number').text(repsRemaining);
						  } else {

							  timeRemaining = parseInt($(this).find('.countdown-number').attr('data-number')) - parseInt(timeDiff);
							  timeRemaining = timeRemaining > 0 ? timeRemaining : 0;
							  console.log('new time reminaing - ', timeRemaining);
							  $(this).find('.countdown-number').text(timeRemaining);
						  } */
							
						  var activityDuration = activities[i].attribute[2].attrValue;
						  
						  timeRemaining = parseInt(activityDuration) - parseInt(timeDiff);
						  
						  console.log('timeRemaining', timeRemaining);
							
						  if (timeRemaining < 0) {
							  timeRemaining = 0;
						  }
						  
						  switch(resultant.rtm) {
							  case 211: 
								  //window.countDown();
								  
								  window.onChannelMessage({text: '211~@$', messageType: "TEXT"}, that.state.currentUserData.sessionData.hostEmail, true);
								  
								 /*  window.setCurrentIndexAndPlay(i, timeRemaining-1, false);
								  window.setNextActivitySync(i); */
								  
								  break;
							  case 212: 
								  //this.resetScript();
								  break;
							  case 213: 
								  /* window.isPaused = true;
								  window.countDown(); */
								  break;
							  case 214: 
								  /* window.isPaused = false;
								  console.log('paused 2');
								  window.countDown(); */
								  
								  console.log('syncScript next_script timeRemaining', timeRemaining);
								  
								  var nextScriptMessage = '214~@$'+i+'~@$'+0+'~@$'+timeRemaining;
								  window.onChannelMessage({text: nextScriptMessage, messageType: "TEXT"}, that.state.currentUserData.sessionData.hostEmail, true);
								  
								  /* window.setCurrentIndexAndPlay(i, timeRemaining-1, false);
								  window.setNextActivitySync(i); */
								  
								  break;
							  case 404: 
								  /* window.isPaused = false;
								  window.countDown(); */
								  break;
						  }

					}
					
				if ( !resultant )
					{
								  console.log('syncScript stop_script');
						window.onChannelMessage({text: "212~@$0", messageType: "TEXT"}, that.state.currentUserData.sessionData.hostEmail, true);
					}
			}
		  

          that.setState({pause: false});
          that.state.player.play();
		  if ( that.state.playerSwap && that.state.playerSwap.src != '' ) { that.state.playerSwap.play(); }
      }, 1000);
    }
	
	playPlayer=(id)=>{
		this.playerFunctions.stopPlayer();
		this.playerFunctions.playPlayer(id);
		this.setState({currentStationId: id, showPlayer: true});
		window['currentStationId'] = id;
	}
	
	stopPlayer=()=>{
		this.playerFunctions.stopPlayer();
		this.setState({currentStationId: "", showPlayer: false});
		window['currentStationId'] = "";
	}
	
	prepareData = () => {

      if (this.state.currentUserData.sessionData.scriptDetail !== undefined && this.state.currentUserData.sessionData.scriptDetail.length > 0) {
        let sessionData = JSON.parse(JSON.stringify(this.state.currentUserData.sessionData.sessionStoreData));
        let lastTime = null;
        let bpmLastTime = null;

        sessionData.forEach((data)=>{
            let details = JSON.parse(data.details);

            if (data.rtm == 205 && details.action == 'recordingButtonStart' && this.recordingStartTime === null) {
                let time = new Date(data.time).getTime();
                this.recordingStartTime = new Date(time);
                this.recordingStartTimeActual = new Date(time);
            } else if (data.rtm == 205 && details.action == 'recordingUpload') {
                if (this.recordingEndTime === null) {
                    this.recordingEndTime = new Date(data.time).getTime();
                }
            } else if (data.rtm == 202 && this.recordingStartTime !== null) {
                let emojiTime = new Date(data.time).getTime();

                if (lastTime != emojiTime) {
                    var scriptObj = {};
                    scriptObj.rtm = parseInt(data.rtm);
                    scriptObj.time = emojiTime;
                    this.syncArr.push(scriptObj);

                    lastTime = emojiTime;
                }

                var emojiObj = {};
                emojiObj.value = details.value;
                emojiObj.name = details.name;
                emojiObj.time = emojiTime;

                this.emojiArr.push(emojiObj);
            } else if (data.rtm == 206 && this.recordingStartTime !== null) {
                let bpmTime = new Date(data.time).getTime();

                if (bpmLastTime != bpmTime) {
                    var scriptObj = {};
                    scriptObj.rtm = parseInt(data.rtm);
                    scriptObj.time = bpmTime;
                    this.syncArr.push(scriptObj);

                    bpmLastTime = bpmTime;
                }

                var bpmObj = {};
                bpmObj.value = details.value;
                bpmObj.name = details.name;
                bpmObj.time = bpmTime;

                this.bpmArr.push(bpmObj);
            } else if (data.rtm != 205 && this.recordingStartTime !== null) {
                var scriptObj = {};
                scriptObj.rtm = parseInt(data.rtm);
                scriptObj.time = new Date(data.time).getTime();
                scriptObj.index = details.scriptIndex;
                scriptObj.timeRemaining = parseInt(details.timeRemaining);

                this.syncArr.push(scriptObj);
            }
        });

        console.log('emoji arr - ', this.emojiArr);
      }
    }
	
	syncScript = (currTime) => {

      let scripts   = this.syncArr;
      let userData  = this.state.currentUserData;
      let that = this;

      that.deadline = new Date(that.recordingStartTimeActual).getTime() + ( currTime * 1000 );
      //console.log('deadline - ', that.deadline, ' - ', currTime);

      if (that.deadline == that.recordingEndTime) {
          window.isPaused = true;
          clearInterval(that.syncTimer);
      } else {

          scripts.forEach((scriptData)=>{
              if (that.deadline == scriptData.time) {
                  console.log('aaaa===111 - ', that.deadline, '========', scriptData.time, scriptData.rtm, scriptData.index);

                  switch(scriptData.rtm) {
                    case 211: 
                       if ( window['startSlider'] )
							{
								window.startSlider();
							}					
                        window.isPaused = false;
						console.log('paused 4');
                        break;
                    case 212: 
                        that.resetScript();
                        break;
                    case 213: 
						console.log('window.isPaused');
                        //window.isPaused = true;
						if ( window['userWhiteboard'] && window['userWhiteboard'][this.state.currentUserData.id] && window['userWhiteboard'][this.state.currentUserData.id].globalActType != "" )
						  {
							  window['userWhiteboard'][this.state.currentUserData.id].doActivityEvents('activityStarted');
						  }
                        break;
                    case 214: 
                        window.isPaused = false;
						console.log("SCRIPT DATA INDEX---", scriptData);
                        if ( window['syncScriptOnDemand'] )
							{
								window.syncScriptOnDemand(scriptData.index);
							}					
                        break;
                    case 404: 
                        window.isPaused = false;
						console.log('paused 6');
                        break;
                    case 202: 
                        that.displayEmojis(scriptData.time);
                        break;
                    case 206: 
                        that.displayBPM(scriptData.time);
                        break;
                  }
              }
          });
      }
    }
	
	pauseVideo = () => {
        if ( this.state.pause === false ) {
			this.playPause();
		}
	}
	
	playVideo = () => {
        if ( this.state.pause === true ) {
			this.playPause('forcePlay');
		}
	}
	
 	render() {
		return (
			<div className={ classnames({ 'main_progress_container': true, 'd-none': !this.state.videoDurationCalculated })}>
				<div className="controls_container_demand">
					{ this.state.pause && <div className="control_icons play_icon" onClick={this.playPause.bind(this)}></div> }
					{ !this.state.pause && <div className="control_icons pause_icon" onClick={this.playPause.bind(this)}></div> }
					<div className="control_icons stop_icon" onClick={this.stopVideo.bind(this)}></div>
					{ !this.state.muted && <div className="control_icons unmute_icon" onClick={this.muteUnmuteVideo.bind(this)}></div> }
					{ this.state.muted && <div className="control_icons mute_icon" onClick={this.muteUnmuteVideo.bind(this)}></div> }
				</div>
				<div className="progress_container" onMouseLeave={this.endSlideIndex}>
					<input type="range" min="0" max="100" defaultValue="0" onChange={this.handleChange} id="progress-bar" step="1" className="progress_main" />
				</div>
				<div className="duration_container">
					<span className="duration_video" id="time-elapsed">0:00</span> / <span className="duration_video" id="video-duration">0:00</span>
				</div>
			</div>
		);
	}
}

export default OndemandPlayer;